@if (renderTag()) {
  <fcom-button class="pr-xxsmall-r" [href]="content().url" [text]="content().title" />
}
